/* kult-home-recent.js — „Zuletzt angesehen“ auf der Startseite (13.10.2026, Fix 14.10.2026).
   Liest die Produkt-IDs, die Horizons RecentlyViewed auf Produktseiten in localStorage („viewedProducts“) ablegt, holt die
   Karten über die Section-Rendering-API (sections/kult-home-recent-cards.liquid) und blendet Spalte und Section ein, sobald
   mindestens eine Karte da ist. Ohne IDs, ohne Treffer oder bei Fehlern bleibt alles versteckt (Spalte inkl. Überschrift).
   Kein Tracking, keine Cookies, nichts verlässt den Shop.
   Markup: Section [data-kult-welcome] > .kult-home-welcome__card > [data-kult-recent][data-url][data-limit] > [data-kult-recent-inner].
   Sobald die Spalte sichtbar ist, bekommt die Karte .kult-home-welcome__card--with-recent (zweispaltiges Raster nur dann).
   14.10.2026: Prüfung nicht mehr auf eine bestimmte Kartenklasse, sondern auf mindestens ein Kind-Element in der Liste
   (die Karten wechselten am 13.10. auf die Bestseller-Karte, der alte Klassen-Check ließ die Spalte immer leer). */
(function () {
  function init(root) {
    var col = (root || document).querySelector('[data-kult-recent]');
    if (!col || col.hasAttribute('data-kult-recent-done')) return;
    col.setAttribute('data-kult-recent-done', '');
    var ids = [];
    try { ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]'); } catch (e) { ids = []; }
    if (!Array.isArray(ids)) return;
    var limit = parseInt(col.getAttribute('data-limit'), 10) || 4;
    ids = ids.map(String).filter(function (x) { return /^\d{1,20}$/.test(x); }).slice(0, limit);
    if (!ids.length) return;
    var url = col.getAttribute('data-url') + '&q=' + encodeURIComponent(ids.map(function (i) { return 'id:' + i; }).join(' OR '));
    fetch(url, { headers: { accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('.kult-home-recent__list');
        if (!list || !list.firstElementChild) return;
        var inner = col.querySelector('[data-kult-recent-inner]');
        if (!inner) return;
        inner.replaceChildren(list);
        var note = doc.querySelector('.kult-home-recent__note');
        if (note) inner.appendChild(note);
        col.hidden = false;
        var card = col.closest('.kult-home-welcome__card');
        if (card) card.classList.add('kult-home-welcome__card--with-recent');
        var sec = col.closest('[data-kult-welcome]');
        if (sec) sec.hidden = false;
      })
      .catch(function () { /* still: nichts anzeigen */ });
  }
  init(document);
  /* Theme-Editor: Section neu geladen → Modul-Skript läuft nicht erneut, daher hier nachziehen */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
